


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IssuerPayload, MUTATE_ISSUER } from '@/store/modules/issuer';
import { ActivityInfo } from '@luxtag/papybase';
import moment from 'moment';
import theme from '@/config/config-ui';
import { user } from '@/plugins/papybase/papybaseInit';

@Component
export default class ProductListContentTable extends Vue {
    @Prop({ default: '' }) public address!: string;

    public headers = [
        {
            text: '',
            sortable: false,
            value: 'num',
            width: '1',
        },
        {
            text: 'Issuer',
            sortable: false,
            value: 'issuer',
            class: 'white--text body-1 font-weight-black',
        },
        // {
        //     text: 'Address',
        //     sortable: false,
        //     value: 'address',
        //     class: 'white--text body-1 font-weight-black',
        // },
        {
            text: 'Action',
            sortable: false,
            value: 'action',
            class: 'white--text body-1 font-weight-black',
        },
        // {
        //     text: 'Action Info',
        //     sortable: false,
        //     value: 'actionInfo',
        //     class: 'white--text body-1 font-weight-black',
        // },
        {
            text: 'Timestamp',
            sortable: false,
            value: 'timestamp',
            class: 'white--text body-1 font-weight-black',
        },
    ];

    get productActivities(): ActivityInfo[] {
        return this.$store.getters.getProductActivities(this.address);
    }

    get issuerEmail(): string {
        let theEmail = this.$store.getters.getEmailOfIssuer(this.address);
        // console.log('theEmail', theEmail);
        if (!theEmail) {
            theEmail = this.address.substring(0, 8);
            user.getEmailByAddress(this.$store.getters.getJwt, this.address).then((res) => {
                // console.log('res', res);
                const issuerPayload: IssuerPayload = {
                    address: this.address,
                    email: res,
                };
                this.$store.commit(MUTATE_ISSUER, issuerPayload);
            });
        }
        return theEmail;
    }

    public translateDate(date: string) {
        const theMoment = moment(date);
        return theMoment.format('MMMM Do YYYY, hh:mm:ss');
    }

    public actionColor(text: string) {
        if (text === 'CLAIM') {
            return theme.success;
        } if (text === 'TRANSFER') {
            return theme.warning;
        }
        return theme.brownGrey;
    }
}
